var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscordBots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#5865F2",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#98A0F7",
    fillRule: "evenodd",
    d: "M149.541 226.539C178.626 226.516 207.754 226.692 236.881 226.539L245.105 181.333H10L19.303 226.539C62.7124 226.255 106.151 226.572 149.541 226.539Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#98A0F7",
    fillRule: "evenodd",
    d: "M215.716 183.071H39.3879V123.93C39.3879 72.0546 78.861 30 127.552 30C176.243 30 215.716 72.0546 215.716 123.93V183.071Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M220.883 151.223V65.4102V151.223ZM34.7578 151.223V65.4102Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#202225",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.37,
    d: "M34.7578 151.223V65.4102M220.883 151.223V65.4102V151.223Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M225.781 118.172H29.8594C26.2539 118.172 23.3281 128.297 23.3281 140.785C23.3281 153.277 26.2539 163.398 29.8594 163.398H225.781C229.387 163.398 232.312 153.277 232.312 140.785C232.312 128.297 229.387 118.172 225.781 118.172Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M145.727 111.754C136.949 124.848 118.691 124.848 109.914 111.754C105.781 105.594 99.1133 101.938 92.0039 101.938H72.2539C64.168 101.938 57.6172 108.922 57.6172 117.535V173.254H198.027V117.535C198.027 108.922 191.473 101.938 183.387 101.938H163.637C156.527 101.938 149.859 105.594 145.727 111.754Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M137.617 97.4453C137.617 91.6836 133.23 87.0078 127.82 87.0078C122.41 87.0078 118.023 91.6836 118.023 97.4453C118.023 103.207 122.41 107.883 127.82 107.883C133.23 107.883 137.617 103.207 137.617 97.4453Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M96.8008 140.207C96.8008 133.48 91.6836 128.027 85.3711 128.027C79.0586 128.027 73.9414 133.48 73.9414 140.207C73.9414 146.93 79.0586 152.383 85.3711 152.383C91.6836 152.383 96.8008 146.93 96.8008 140.207ZM181.699 140.207C181.699 133.48 176.582 128.027 170.27 128.027C163.957 128.027 158.84 133.48 158.84 140.207C158.84 146.93 163.957 152.383 170.27 152.383C176.582 152.383 181.699 146.93 181.699 140.207Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M202.922 209.551C202.922 206.672 200.73 204.332 198.027 204.332C195.32 204.332 193.129 206.672 193.129 209.551C193.129 212.434 195.32 214.77 198.027 214.77C200.73 214.77 202.922 212.434 202.922 209.551ZM186.598 209.551C186.598 206.672 184.406 204.332 181.699 204.332C178.992 204.332 176.801 206.672 176.801 209.551C176.801 212.434 178.992 214.77 181.699 214.77C184.406 214.77 186.598 212.434 186.598 209.551ZM170.27 209.551C170.27 206.672 168.078 204.332 165.371 204.332C162.668 204.332 160.473 206.672 160.473 209.551C160.473 212.434 162.668 214.77 165.371 214.77C168.078 214.77 170.27 212.434 170.27 209.551Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordBots);
export default __webpack_public_path__ + "static/media/DiscordBots.7f16df206419166767e1623ca2801945.svg";
export { ForwardRef as ReactComponent };